import Breadcrumbs   from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";

const CustomBreadcrumbs =({ items = [] })=> {
  if (!items.length) return null;
  return (
    <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
      {items.map((item, idx) =>
        item.href ? (
          <Link
            key={item.label}
            underline="hover"
            color="inherit"
            href={item.disable ? undefined : item.href}
            onClick={(e) => {
              if (item.disable) {
                e.preventDefault();
              }
            }}
            sx={{ 
              fontSize: { xs: "0.75rem", sm: "0.95rem" },
              pointerEvents: item.disable ? 'none' : 'auto',
              opacity: item.disable ? 0.5 : 1,
              cursor: item.disable ? 'not-allowed' : 'pointer',
            }}
          >
            {item.label}
          </Link>
        ) : (
          <Typography
            key={item.label}
            color="text.primary"
            sx={{ fontSize: { xs: "0.75rem", sm: "0.95rem" } }}
          >
            {item.label}
          </Typography>
        )
      )}
    </Breadcrumbs >
  );
}
CustomBreadcrumbs.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node.isRequired,
      href: PropTypes.string,
    })
  ),
};

export default CustomBreadcrumbs;
